module.exports = __webpack_public_path__ + "static/media/note-4_5.9decc811.png";